var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlayEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 53.333,
    viewBox: "0 0 180 53.333",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m205.1 176.1-0.743 0.711c-2.91 3.079-4.628 7.86-4.628 14.051v-1.457 221.16 0.051-0.055-1.461c0 6.704 2.003 11.754 5.359 14.782l123.9-123.9-123.89-123.89m-5.371 234.53c0 0.551 0.015 1.086 0.043 1.613-0.028-0.523-0.043-1.062-0.043-1.613m0.043 1.637c0 7e-3 0 0.015 3e-3 0.023-3e-3 -8e-3 -3e-3 -0.016-3e-3 -0.023m3e-3 0.07v0.012-0.012"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient68",
    x2: 1,
    gradientTransform: "matrix(-167.82 -167.82 167.82 -167.82 318 412.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00a0ff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00a1ff",
    offset: 0.0065744
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00beff",
    offset: 0.2601
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00d2ff",
    offset: 0.5122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00dfff",
    offset: 0.7604
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00e3ff",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m370.28 257.22 0.942 0.535 48.929 27.801c4.665 2.652 7.774 5.867 9.325 9.269-1.547-3.402-4.657-6.621-9.325-9.273l-48.929-27.801-0.942-0.531m0.012 1.465-41.305 41.312 41.301 41.305 49.863-28.328c6.332-3.598 9.887-8.235 10.481-12.973v-0.019c-0.594-4.727-4.149-9.368-10.481-12.965l-49.859-28.332"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient88",
    x2: 1,
    gradientTransform: "matrix(-241.97 0 0 -241.97 438.34 299.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe000",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbd00",
    offset: 0.4087
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffa500",
    offset: 0.7754
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff9c00",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath98"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m213.93 171.39c-3.461 0-6.481 1.125-8.836 3.25l4e-3 4e-3c2.355-2.125 5.379-3.254 8.84-3.254 0.3 0 0.605 8e-3 0.914 0.023-0.313-0.015-0.622-0.023-0.922-0.023m4e-3 1.465c-3.461-4e-3 -6.481 1.125-8.836 3.25v3e-3l123.89 123.89 41.305-41.312-145.15-82.473c-4.016-2.277-7.821-3.355-11.203-3.355m-8.871 1.812c-0.219 0.199-0.434 0.41-0.645 0.629l0.645-0.629"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient104",
    x2: 1,
    gradientTransform: "matrix(-227.58 -227.58 227.58 -227.58 348.27 277.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff3a44",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#c31162",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath114"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m328.98 299.99-123.9 123.9c2.355 2.121 5.371 3.246 8.828 3.246 3.391 0 7.199-1.082 11.223-3.363l145.15-82.473-41.301-41.305m42.235 42.238-146.08 83c-4.024 2.282-7.832 3.364-11.223 3.364h-0.043 0.059c3.383 0 7.187-1.078 11.207-3.36l146.08-83.004m-157.38 86.364"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient126",
    x2: 1,
    gradientTransform: "matrix(101.62 -101.62 101.62 101.62 172.97 498.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32a071",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2da771",
    offset: 0.0685
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15cf74",
    offset: 0.4762
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06e775",
    offset: 0.8009
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00f076",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m370.28 257.22 0.942 0.535-0.942-0.535"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient148",
    x2: 1,
    gradientTransform: "matrix(-241.97 0 0 -241.97 438.34 299.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ccb300",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cc9700",
    offset: 0.4087
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cc8400",
    offset: 0.7754
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cc7d00",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath158"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m213.94 171.39c-3.461 0-6.485 1.129-8.84 3.254l-4e-3 -4e-3c-8e-3 8e-3 -0.02 0.019-0.031 0.027l-0.645 0.629c-0.02 0.02-0.039 0.043-0.063 0.066l0.743 0.743c2.355-2.125 5.375-3.254 8.836-3.25 3.382 0 7.187 1.078 11.203 3.355l145.15 82.473 0.93-0.93-0.942-0.535-145.14-82.469c-3.66-2.074-7.141-3.156-10.285-3.336-0.309-0.015-0.614-0.023-0.914-0.023"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient164",
    x2: 1,
    gradientTransform: "matrix(-227.58 -227.58 227.58 -227.58 348.27 277.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#cc2e36",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9c0e4e",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath176"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m204.36 175.36c-2.91 3.079-4.628 7.856-4.628 14.051v1.457c0-6.191 1.718-10.972 4.628-14.051l0.743-0.711-0.743-0.746"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient190",
    x2: 1,
    gradientTransform: "matrix(-167.82 -167.82 167.82 -167.82 318 412.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008de0",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008de0",
    offset: 0.0065744
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00a7e0",
    offset: 0.2601
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00b8e0",
    offset: 0.5122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00c4e0",
    offset: 0.7604
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00c7e0",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath200"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m204.36 175.36 0.743 0.746v-3e-3l-0.743-0.743"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient206",
    x2: 1,
    gradientTransform: "matrix(-227.58 -227.58 227.58 -227.58 348.27 277.04)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0333c",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ab0f56",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath218"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m371.22 257.75-0.93 0.93 49.859 28.332c6.332 3.597 9.887 8.238 10.481 12.965 0-1.735-0.387-3.469-1.156-5.157-1.551-3.402-4.66-6.617-9.325-9.269l-48.929-27.801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient228",
    x2: 1,
    gradientTransform: "matrix(-241.97 0 0 -241.97 438.34 299.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0c500",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e0a600",
    offset: 0.4087
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e09100",
    offset: 0.7754
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#e08900",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath240"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m430.63 300c-0.594 4.738-4.149 9.375-10.481 12.973l-49.863 28.328 0.93 0.93h4e-3l48.929-27.801c6.981-3.969 10.477-9.199 10.481-14.43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient250",
    x2: 1,
    gradientTransform: "matrix(-241.97 0 0 -241.97 438.34 299.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe840",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffce40",
    offset: 0.4087
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffbc40",
    offset: 0.7754
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffb540",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath262"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m199.73 409.1v1.461 0.055 0.012c0 0.551 0.015 1.09 0.043 1.613v0.024c0 7e-3 0 0.015 3e-3 0.023v0.047 0.012c0.301 5.332 1.957 9.492 4.582 12.269l0.731-0.734c-3.356-3.028-5.359-8.078-5.359-14.782m5.339 16.215 0.028 0.028c-8e-3 -0.012-0.02-0.02-0.028-0.028"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient276",
    x2: 1,
    gradientTransform: "matrix(-167.82 -167.82 167.82 -167.82 318 412.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40b8ff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40b9ff",
    offset: 0.0065744
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40ceff",
    offset: 0.2601
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40ddff",
    offset: 0.5122
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40e7ff",
    offset: 0.7604
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40eaff",
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath288"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m370.28 341.3-145.15 82.473c-4.024 2.281-7.832 3.363-11.223 3.363-3.457 0-6.473-1.125-8.828-3.246l-0.731 0.734c0.231 0.242 0.465 0.477 0.711 0.699 8e-3 8e-3 0.02 0.016 0.028 0.024 2.336 2.105 5.32 3.23 8.746 3.25h0.031 0.043c3.391 0 7.199-1.082 11.223-3.364l146.08-83-4e-3 -3e-3 -0.93-0.93"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient300",
    x2: 1,
    gradientTransform: "matrix(101.62 -101.62 101.62 101.62 172.97 498.24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65b895",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62bd95",
    offset: 0.0685
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#50db97",
    offset: 0.4762
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44ed98",
    offset: 0.8009
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40f498",
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333 0 0 -1.3333 -13.333 66.667)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1400 100h-1250c-27.5 0-50 22.5-50 50v300c0 27.5 22.5 50 50 50h1250c27.5 0 50-22.5 50-50v-300c0-27.5-22.5-50-50-50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1400 500h-1250c-27.5 0-50-22.5-50-50v-300c0-27.5 22.5-50 50-50h1250c27.5 0 50 22.5 50 50v300c0 27.5-22.5 50-50 50m0-8c23.16 0 42-18.844 42-42v-300c0-23.16-18.84-42.004-42-42.004h-1250c-23.156 0-42 18.844-42 42.004v300c0 23.156 18.844 42 42 42h1250",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m574.18 397.57c0-8.378-2.481-15.05-7.45-20.027-5.644-5.918-13-8.879-22.043-8.879-8.66 0-16.023 3-22.078 9.008-6.066 6.004-9.093 13.449-9.093 22.332 0 8.887 3.027 16.328 9.093 22.336 6.055 6.004 13.418 9.008 22.078 9.008 4.297 0 8.411-0.84 12.317-2.516 3.906-1.68 7.039-3.91 9.383-6.703l-5.274-5.277c-3.972 4.746-9.441 7.117-16.426 7.117-6.316 0-11.777-2.219-16.386-6.66-4.61-4.446-6.914-10.211-6.914-17.305s2.304-12.859 6.914-17.305c4.609-4.441 10.07-6.66 16.386-6.66 6.7 0 12.286 2.231 16.758 6.699 2.903 2.911 4.582 6.957 5.031 12.153h-21.789v7.207h29.075c0.281-1.567 0.418-3.071 0.418-4.528"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m574.18 397.57h-1c-8e-3 -8.187-2.399-14.546-7.157-19.32l-0.011-8e-3 -4e-3 -8e-3c-5.465-5.714-12.489-8.558-21.321-8.57-8.429 0.012-15.484 2.887-21.375 8.715-5.878 5.84-8.785 12.969-8.796 21.625 0.011 8.66 2.918 15.785 8.796 21.621 5.891 5.832 12.946 8.711 21.375 8.723 4.168 0 8.137-0.813 11.922-2.434 3.789-1.633 6.782-3.773 9.012-6.43l0.766 0.645-0.707 0.707-5.274-5.281 0.707-0.703 0.77 0.64c-4.157 4.981-9.992 7.492-17.196 7.477-6.55 8e-3 -12.312-2.332-17.078-6.942-4.812-4.625-7.23-10.714-7.222-18.023-8e-3 -7.309 2.41-13.398 7.222-18.023 4.766-4.61 10.528-6.95 17.078-6.942 6.922-0.012 12.821 2.336 17.465 6.992 3.102 3.11 4.86 7.418 5.321 12.774l0.093 1.086h-21.879v5.207h28.075v1l-0.985-0.176c0.274-1.516 0.403-2.957 0.403-4.352h2c0 1.52-0.141 3.082-0.434 4.707l-0.148 0.821h-30.911v-9.207h22.789v1l-0.996 0.086c-0.441-5.032-2.043-8.821-4.742-11.532-4.297-4.281-9.57-6.394-16.051-6.406-6.082 8e-3 -11.242 2.102-15.691 6.379-4.406 4.262-6.598 9.703-6.609 16.586 0.011 6.883 2.203 12.324 6.609 16.586 4.449 4.277 9.609 6.371 15.691 6.379 6.762-0.016 11.868-2.25 15.661-6.762l0.703-0.836 6.043 6.051 0.648 0.648-0.59 0.7c-2.457 2.929-5.73 5.254-9.754 6.98-4.031 1.731-8.285 2.598-12.711 2.598-8.89 8e-3 -16.562-3.117-22.785-9.301-6.246-6.172-9.394-13.93-9.386-23.043-8e-3 -9.109 3.14-16.871 9.39-23.047 6.219-6.18 13.891-9.301 22.781-9.293 9.258-8e-3 16.938 3.067 22.766 9.188l-0.723 0.691 0.707-0.707c5.18 5.176 7.75 12.168 7.743 20.734h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m620.28 422.63h-27.324v-19.024h24.641v-7.21h-24.641v-19.024h27.324v-7.371h-35.027v60h35.027v-7.371"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m620.28 422.63v1h-28.324v-21.024h24.641v-5.207l-24.641-3e-3v-21.024h27.324v-5.371h-33.027v58h33.027v-6.371h1v1-1h1v8.371h-37.027v-62h37.027v9.371h-27.324v17.024h24.641v9.21h-24.641v17.024h27.324v1h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m652.79 370h-7.715v52.629h-16.758v7.371h41.231v-7.371h-16.758v-52.629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m652.79 370v1h-6.715v52.629h-16.758v5.371h39.231v-5.371h-16.758v-53.629h1v1-1h1v51.629h16.758v9.371h-43.231v-9.371h16.758v-52.629h9.715v1h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m699.38 370v60h7.707v-60h-7.707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m699.38 370h1v59h5.707v-58h-6.707v-1h1-1v-1h8.707v62h-9.707v-62h1v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m741.28 370h-7.715v52.629h-16.757v7.371h41.23v-7.371h-16.758v-52.629"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m741.28 370v1h-6.715v52.629h-16.757v5.371h39.23v-5.371h-16.758v-53.629h1v1-1h1v51.629h16.758v9.371h-43.23v-9.371h16.757v-52.629h9.715v1h-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m797.79 382.78c4.441-4.496 9.875-6.742 16.301-6.742s11.863 2.246 16.297 6.742c4.445 4.496 6.672 10.243 6.672 17.223s-2.227 12.727-6.672 17.223c-4.434 4.496-9.871 6.742-16.297 6.742s-11.86-2.246-16.301-6.742c-4.434-4.496-6.66-10.243-6.66-17.223s2.226-12.727 6.66-17.223zm38.301-5.023c-5.899-6.066-13.235-9.094-22-9.094-8.774 0-16.106 3.028-21.992 9.094-5.903 6.059-8.84 13.476-8.84 22.246s2.937 16.188 8.84 22.246c5.886 6.067 13.218 9.098 21.992 9.098 8.719 0 16.035-3.047 21.961-9.137 5.918-6.09 8.879-13.492 8.879-22.207 0-8.77-2.954-16.187-8.84-22.246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m797.79 382.78-0.711-0.703c4.606-4.676 10.352-7.051 17.012-7.039 6.656-0.012 12.41 2.363 17.008 7.039 4.636 4.68 6.968 10.735 6.961 17.926 7e-3 7.191-2.325 13.246-6.961 17.926-4.598 4.676-10.352 7.051-17.008 7.039-6.66 0.012-12.406-2.363-17.012-7.039-4.625-4.68-6.961-10.735-6.949-17.926-0.012-7.191 2.324-13.246 6.949-17.926l1.422 1.406c-4.242 4.317-6.363 9.747-6.371 16.52 8e-3 6.773 2.129 12.203 6.371 16.52 4.281 4.316 9.394 6.433 15.59 6.445 6.191-0.012 11.316-2.129 15.586-6.445 4.25-4.317 6.371-9.747 6.379-16.52-8e-3 -6.773-2.129-12.203-6.379-16.52-4.27-4.316-9.395-6.433-15.586-6.445-6.196 0.012-11.309 2.129-15.59 6.445zm38.301-5.023-0.715 0.695c-5.734-5.875-12.746-8.777-21.285-8.789-8.543 0.012-15.555 2.914-21.278 8.789l-0.027 0.031 0.027-0.031c-5.722 5.895-8.546 13.004-8.554 21.551 8e-3 8.547 2.832 15.656 8.554 21.551 5.723 5.875 12.735 8.781 21.278 8.793 8.484-0.012 15.48-2.93 21.246-8.836 5.742-5.922 8.582-13.02 8.594-21.508-0.012-8.547-2.844-15.656-8.555-21.551l0.715-0.695 0.719-0.695c6.062 6.226 9.128 13.949 9.121 22.941 7e-3 8.941-3.071 16.648-9.161 22.902-6.093 6.278-13.726 9.453-22.679 9.442-9 0.011-16.656-3.149-22.711-9.403v4e-3c-6.074-6.23-9.129-13.953-9.121-22.945-8e-3 -8.992 3.047-16.715 9.121-22.945l0.027-0.028-0.027 0.032c6.055-6.254 13.711-9.407 22.711-9.399 8.996-8e-3 16.652 3.145 22.719 9.399l-0.719 0.695"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m855.75 370v60h9.383l29.16-46.676h0.332l-0.332 11.563v35.113h7.715v-60h-8.047l-30.508 48.938h-0.332l0.332-11.567v-37.371h-7.703"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m855.75 370h1v59h7.828l29.16-46.676h1.914l-0.359 12.578v34.098h5.715v-58h-6.492l-30.508 48.938h-1.914l0.359-12.583v-36.355h-6.703v-1h1-1v-1h8.703v38.387l-0.332 11.578-1-0.027v-1h0.332v1l-0.848-0.532 30.801-49.406h9.602v62h-9.715v-36.125l0.332-11.578 1 0.027v1h-0.332v-1l0.848 0.531-29.454 47.145h-10.937v-62h1v1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1169.4 200h18.66v125.01h-18.66zm168.07 79.98-21.39-54.199h-0.64l-22.2 54.199h-20.1l33.29-75.753-18.98-42.137h19.47l51.3 117.89zm-105.82-65.781c-6.12 0-14.64 3.055-14.64 10.617 0 9.649 10.62 13.348 19.78 13.348 8.21 0 12.06-1.769 17.05-4.184-1.45-11.578-11.42-19.781-22.19-19.781zm2.25 68.516c-13.51 0-27.5-5.953-33.29-19.141l16.56-6.914c3.54 6.914 10.13 9.168 17.05 9.168 9.65 0 19.46-5.793 19.62-16.086v-1.285c-3.38 1.93-10.61 4.824-19.46 4.824-17.85 0-36.03-9.808-36.03-28.144 0-16.727 14.64-27.504 31.04-27.504 12.55 0 19.46 5.629 23.81 12.222h0.64v-9.648h18.01v47.93c0 22.191-16.56 34.578-37.95 34.578zm-115.32-17.953h-26.54v42.851h26.54c13.95 0 21.87-11.55 21.87-21.425 0-9.688-7.92-21.426-21.87-21.426zm-0.48 60.25h-44.71v-125.01h18.65v47.363h26.06c20.68 0 41.01 14.973 41.01 38.825 0 23.851-20.33 38.824-41.01 38.824zm-243.81-110.84c-12.891 0-23.684 10.793-23.684 25.617 0 14.98 10.793 25.937 23.684 25.937 12.727 0 22.715-10.957 22.715-25.937 0-14.824-9.988-25.617-22.715-25.617zm21.426 58.804h-0.645c-4.187 4.993-12.246 9.504-22.394 9.504-21.266 0-40.758-18.687-40.758-42.691 0-23.844 19.492-42.371 40.758-42.371 10.148 0 18.207 4.512 22.394 9.664h0.645v-6.121c0-16.274-8.699-24.973-22.715-24.973-11.438 0-18.527 8.219-21.43 15.145l-16.269-6.766c4.672-11.277 17.078-25.133 37.699-25.133 21.91 0 40.437 12.891 40.437 44.305v76.363h-17.722zm30.609-72.98h18.688v125.02h-18.688zm46.238 41.242c-0.484 16.434 12.727 24.809 22.231 24.809 7.416 0 13.696-3.703 15.786-9.024zm57.997 14.176c-3.54 9.508-14.34 27.066-36.411 27.066-21.91 0-40.113-17.238-40.113-42.531 0-23.844 18.043-42.531 42.207-42.531 19.497 0 30.777 11.922 35.447 18.848l-14.5 9.668c-4.83-7.09-11.44-11.762-20.947-11.762-9.504 0-16.269 4.351-20.621 12.887l56.868 23.523zm-453.08 14.016v-18.043h43.175c-1.289-10.149-4.672-17.559-9.828-22.715-6.281-6.285-16.109-13.211-33.347-13.211-26.583 0-47.364 21.426-47.364 48.008s20.781 48.011 47.364 48.011c14.339 0 24.808-5.64 32.542-12.89l12.727 12.726c-10.793 10.313-25.133 18.207-45.269 18.207-36.411 0-67.02-29.644-67.02-66.054s30.609-66.051 67.02-66.051c19.656 0 34.476 6.441 46.074 18.527 11.922 11.922 15.629 28.676 15.629 42.207 0 4.192-0.321 8.055-0.969 11.278zm110.79-55.258c-12.891 0-24.008 10.633-24.008 25.777 0 15.305 11.117 25.777 24.008 25.777 12.886 0 24.003-10.472 24.003-25.777 0-15.144-11.117-25.777-24.003-25.777zm0 68.308c-23.524 0-42.696-17.882-42.696-42.531 0-24.488 19.172-42.531 42.696-42.531 23.519 0 42.691 18.043 42.691 42.531 0 24.649-19.172 42.531-42.691 42.531zm93.132-68.308c-12.886 0-24.004 10.633-24.004 25.777 0 15.305 11.118 25.777 24.004 25.777 12.887 0 24.004-10.472 24.004-25.777 0-15.144-11.117-25.777-24.004-25.777zm0 68.308c-23.523 0-42.691-17.882-42.691-42.531 0-24.488 19.168-42.531 42.691-42.531 23.52 0 42.692 18.043 42.692 42.531 0 24.649-19.172 42.531-42.692 42.531"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m205.1 176.1-0.743 0.711c-2.91 3.079-4.628 7.86-4.628 14.051v-1.457 221.16 0.051-0.055-1.461c0 6.704 2.003 11.754 5.359 14.782l123.9-123.9-123.89-123.89m-5.371 234.53c0 0.551 0.015 1.086 0.043 1.613-0.028-0.523-0.043-1.062-0.043-1.613m0.043 1.637c0 7e-3 0 0.015 3e-3 0.023-3e-3 -8e-3 -3e-3 -0.016-3e-3 -0.023m3e-3 0.07v0.012-0.012",
    fill: "url(#linearGradient68)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m370.28 257.22 0.942 0.535 48.929 27.801c4.665 2.652 7.774 5.867 9.325 9.269-1.547-3.402-4.657-6.621-9.325-9.273l-48.929-27.801-0.942-0.531m0.012 1.465-41.305 41.312 41.301 41.305 49.863-28.328c6.332-3.598 9.887-8.235 10.481-12.973v-0.019c-0.594-4.727-4.149-9.368-10.481-12.965l-49.859-28.332",
    fill: "url(#linearGradient88)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m213.93 171.39c-3.461 0-6.481 1.125-8.836 3.25l4e-3 4e-3c2.355-2.125 5.379-3.254 8.84-3.254 0.3 0 0.605 8e-3 0.914 0.023-0.313-0.015-0.622-0.023-0.922-0.023m4e-3 1.465c-3.461-4e-3 -6.481 1.125-8.836 3.25v3e-3l123.89 123.89 41.305-41.312-145.15-82.473c-4.016-2.277-7.821-3.355-11.203-3.355m-8.871 1.812c-0.219 0.199-0.434 0.41-0.645 0.629l0.645-0.629",
    fill: "url(#linearGradient104)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath114)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m328.98 299.99-123.9 123.9c2.355 2.121 5.371 3.246 8.828 3.246 3.391 0 7.199-1.082 11.223-3.363l145.15-82.473-41.301-41.305m42.235 42.238-146.08 83c-4.024 2.282-7.832 3.364-11.223 3.364h-0.043 0.059c3.383 0 7.187-1.078 11.207-3.36l146.08-83.004m-157.38 86.364",
    fill: "url(#linearGradient126)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m214.85 171.41c3.144 0.18 6.625 1.262 10.285 3.336l145.14 82.469-145.14-82.469c-3.657-2.078-7.141-3.156-10.285-3.336m-9.758 3.227-0.031 0.027c0.011-8e-3 0.023-0.019 0.031-0.027m-0.676 0.656-0.063 0.062v4e-3c0.024-0.023 0.043-0.046 0.063-0.066"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m370.28 257.22 0.942 0.535-0.942-0.535",
    fill: "url(#linearGradient148)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m213.94 171.39c-3.461 0-6.485 1.129-8.84 3.254l-4e-3 -4e-3c-8e-3 8e-3 -0.02 0.019-0.031 0.027l-0.645 0.629c-0.02 0.02-0.039 0.043-0.063 0.066l0.743 0.743c2.355-2.125 5.375-3.254 8.836-3.25 3.382 0 7.187 1.078 11.203 3.355l145.15 82.473 0.93-0.93-0.942-0.535-145.14-82.469c-3.66-2.074-7.141-3.156-10.285-3.336-0.309-0.015-0.614-0.023-0.914-0.023",
    fill: "url(#linearGradient164)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m204.36 175.36c-2.91 3.079-4.628 7.86-4.628 14.051v4e-3c0-6.195 1.718-10.972 4.628-14.051v-4e-3"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m204.36 175.36c-2.91 3.079-4.628 7.856-4.628 14.051v1.457c0-6.191 1.718-10.972 4.628-14.051l0.743-0.711-0.743-0.746",
    fill: "url(#linearGradient190)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m204.36 175.36 0.743 0.746v-3e-3l-0.743-0.743",
    fill: "url(#linearGradient206)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m429.47 294.82c0.769 1.688 1.156 3.422 1.156 5.157v7e-3c0-1.738-0.387-3.472-1.156-5.164"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m371.22 257.75-0.93 0.93 49.859 28.332c6.332 3.597 9.887 8.238 10.481 12.965 0-1.735-0.387-3.469-1.156-5.157-1.551-3.402-4.66-6.617-9.325-9.269l-48.929-27.801",
    fill: "url(#linearGradient228)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m430.63 299.99v4e-3c-4e-3 5.231-3.5 10.461-10.481 14.43l-48.929 27.801h-4e-3l4e-3 3e-3 48.929-27.8c6.989-3.969 10.489-9.207 10.481-14.438",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m430.63 300c-0.594 4.738-4.149 9.375-10.481 12.973l-49.863 28.328 0.93 0.93h4e-3l48.929-27.801c6.981-3.969 10.477-9.199 10.481-14.43",
    fill: "url(#linearGradient250)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m199.73 410.62v0.012-0.012m0.043 1.625v0.024-0.024m3e-3 0.047v0.047-0.047m0 0.059c0.579 10.273 6.165 16.207 14.067 16.242-3.426-0.02-6.41-1.145-8.746-3.25v4e-3l-0.028-0.028c-0.246-0.222-0.48-0.457-0.711-0.699-2.625-2.777-4.281-6.937-4.582-12.269",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath262)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m199.73 409.1v1.461 0.055 0.012c0 0.551 0.015 1.09 0.043 1.613v0.024c0 7e-3 0 0.015 3e-3 0.023v0.047 0.012c0.301 5.332 1.957 9.492 4.582 12.269l0.731-0.734c-3.356-3.028-5.359-8.078-5.359-14.782m5.339 16.215 0.028 0.028c-8e-3 -0.012-0.02-0.02-0.028-0.028",
    fill: "url(#linearGradient276)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m213.84 428.59h0.031-0.031",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m370.28 341.3-145.15 82.473c-4.024 2.281-7.832 3.363-11.223 3.363-3.457 0-6.473-1.125-8.828-3.246l-0.731 0.734c0.231 0.242 0.465 0.477 0.711 0.699 8e-3 8e-3 0.02 0.016 0.028 0.024 2.336 2.105 5.32 3.23 8.746 3.25h0.031 0.043c3.391 0 7.199-1.082 11.223-3.364l146.08-83-4e-3 -3e-3 -0.93-0.93",
    fill: "url(#linearGradient300)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayEn);
export default __webpack_public_path__ + "static/media/google-play-en.76ca1cf04788f5c2b15721aa0df93c3a.svg";
export { ForwardRef as ReactComponent };